import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/devices.js';
import form from '../forms/devices.js';
import * as types from '../types.js';

const devices = function()
{

	let devices_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_devices, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_device, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: data.name,
				type: data.type,
				address: data.address,
				port: Number(data.port),
				timeout: Number(data.timeout)
			};
			if (old_data)
				return await api.call(api.update_device, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_device, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Dispositivo', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do dispositivo' },
		{ index: 3, field: 'name', label: 'Nome', types: [types.number(0, 2)], placeholder: '', title: 'Nome do dispositivo' },
		{ index: 4, field: 'type', label: 'Tipo', types: [types.opt_device_type(), types.datalist()], placeholder: '', title: 'Tipo' },
		{ index: 5, field: 'address', label: 'Endereço', types: [], placeholder: '0.0.0.0', title: 'Endereço IP do dispositivo' },
		{ index: 6, field: 'port', label: 'Porta', types: [types.number(0)], placeholder: '0', title: 'Porta de conexão' },
		{ index: 7, field: 'timeout', label: 'Timeout', types: [types.number(0)], placeholder: '0', title: 'Tempo máximo de resposta em segundos' },
	];

	devices_crud.run(
		'devices',
		'Dispositivos',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default devices;

